'use client';

import {
  defaultSortByAtom,
  enableHomeNewsletterAtom,
  heroAtom,
  homeCssAtom,
  homeCssVariablesAtom,
  homeJsAtom,
  homeNewsletterDescriptionAtom,
  homeNewsletterTitleAtom,
  metaDescriptionAtom,
  metaTitleAtom,
  showSortMenuAtom,
  showTagTabsAtom,
} from 'app/blog/[domain]/_components/design-state';
import type { schema } from 'database';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

export type HydrateHomeAtoms = {
  hero: string;
  cssVariables?: schema.HomeCssVariables | null;
  showSortMenu?: boolean;
  showTagTabs?: boolean;
  defaultSortBy?: schema.SortByOption;
  metaTitle?: string;
  metaDescription?: string;
  enableHomeNewsletter?: boolean;
  homeNewsletterTitle?: string | null;
  homeNewsletterDescription?: string | null;
  customCss?: string | null;
  customJs?: string | null;
};

export function HydrateHomeAtoms(props: HydrateHomeAtoms) {
  const store = useStore();
  // Initialize optional values too: later RSC refreshes must not hydrate
  // newly populated fields while design controls are already subscribed.
  useHydrateAtoms(
    [
      [heroAtom, props.hero],
      [showSortMenuAtom, props.showSortMenu ?? showSortMenuAtom.init],
      [showTagTabsAtom, props.showTagTabs ?? showTagTabsAtom.init],
      [defaultSortByAtom, props.defaultSortBy ?? defaultSortByAtom.init],
      [metaTitleAtom, props.metaTitle ?? metaTitleAtom.init],
      [metaDescriptionAtom, props.metaDescription ?? metaDescriptionAtom.init],
      [
        enableHomeNewsletterAtom,
        props.enableHomeNewsletter ?? enableHomeNewsletterAtom.init,
      ],
      [
        homeNewsletterTitleAtom,
        props.homeNewsletterTitle ?? homeNewsletterTitleAtom.init,
      ],
      [
        homeNewsletterDescriptionAtom,
        props.homeNewsletterDescription ?? homeNewsletterDescriptionAtom.init,
      ],
      [homeCssAtom, props.customCss ?? homeCssAtom.init],
      [homeJsAtom, props.customJs ?? homeJsAtom.init],
      [homeCssVariablesAtom, props.cssVariables ?? homeCssVariablesAtom.init],
    ] as const,
    { store },
  );

  return <></>;
}
